/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ips-checked-card[_ngcontent-%COMP%]{background-color:#dff0d8;border-color:#228b22}.ips-checked-card[_ngcontent-%COMP%]   .survey-check[_ngcontent-%COMP%]{color:#228b22}.survey-check[_ngcontent-%COMP%]{font-size:14pt;color:#e4e4e4}.status-icon.answer-icon-bgi[_ngcontent-%COMP%], .status-icon.question-icon-bgi[_ngcontent-%COMP%]{width:24px;height:24px}.survey-question-image[_ngcontent-%COMP%]{width:150px;min-width:150px}"];
export { styles as styles };
